import {useEffect, useRef, useState} from 'react';

import {generateSsoLoginLink} from 'src/openapi/admin/apis/SsoApi';
import {useAppDispatch} from 'src/store/hooks';

const FALLBACK_LOGIN_URL = 'https://my.pitchbook.com';

type UseSsoLoginLinkReturn = {
    loading: boolean,
    url: string,
};

export function useSsoLoginLink(): UseSsoLoginLinkReturn {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(true);
    const [url, setUrl] = useState(FALLBACK_LOGIN_URL);
    const abortControllerRef = useRef<AbortController | null>(null);

    useEffect(() => {
        const controller = new AbortController();
        abortControllerRef.current = controller;
        setLoading(true);

        (async () => {
            try {
                const response = await dispatch(
                    generateSsoLoginLink({signal: controller.signal}),
                );

                if (controller.signal.aborted) {
                    return;
                }

                if (response.payload?.success && response.payload.data?.url) {
                    setUrl(response.payload.data.url);
                }
            } catch (err) {
                if ((err as {name?: string})?.name === 'AbortError') {
                    return;
                }
            } finally {
                if (abortControllerRef.current === controller) {
                    abortControllerRef.current = null;
                }
                setLoading(false);
            }
        })();

        return () => {
            controller.abort();
        };
    }, [dispatch]);

    return {loading, url};
}
